<template>
    <div class="activity-content">
        <div class="activity-banner">
            <img src="../../assets/images/sblj-banner@2x.png" alt />
            <a href="javascript:;" class="go-back activity-back" @click="e=>this.$router.back()"></a>
        </div>
        <div class="activity-list">
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-1@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动时间</h5>
                    <div class="text-item-warp">
                        <div class="text-item">2020年4月17日-2020年7月6日</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-2@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动对象</h5>
                    <div class="text-item-warp">
                        <div class="text-item">上海农商银行信用卡微信支付首次绑卡客户</div>
                        <div class="apply-button-wrapper">
                             <a href="javascript:;" @click="e=>{this.$test('WeChat a-register-2');$listeners.routePusht('https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX02&validate=20991231')}"  class="apply-activity-btn" ></a>
                        </div> 
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/sblj-icon-1@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动内容</h5>
                    <div class="text-item-warp">
                        <p>
                            <span>10元立减金</span>等你领
                        </p>
                        <div
                            class="text-item"
                        >活动期间,上海农商银行信用卡客户首次绑定微信支付,有机会获赠微信支付10元立减金。该立减金在使用上海农商银行信用卡进行微信支付时,可在订单支付金额大于10元时进行抵扣(生活缴费、理财、少数特定商户不可使用),本次活动最高立减10元。活动名额共计12000个,名额有限,先到先得,用完为止。</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item a-footer-item">
                <div class="rule-details">
                    <h5>活动细则</h5>
                    <div class="rule-text">
                        <p>1.活动中首次绑卡客户是指微信钱包客户历史上首次绑定上海农商银行信用卡的客户。同一身份证号码实名信息视为同一客户,同一实名信息的不同微信号视为同一客户。同一客户解绑后再绑定、更换微信号绑定或非首次绑定上海农商银行信用卡,均不属于首次绑定。</p>
                        <div class="more-text" v-show="isShow">
                            <p>2.活动期间,同一客户仅可领取一次10元立减金。获得立减金奖励的客户可在“微信-我-卡包”中查看立减金。立减金自领取之日起10天内有效,到期后自动失效,如客户未在立减金有效期内使用,视同放弃,不再补偿。立减金不可拆分、不得提现、无法转赠。</p>
                            <p>3.活动期间,使用立减金完成的订单,如发生全额退款,仅退还客户实际支付的金额；如发生部分退款,则按比例退还客户实际支付的金额。退款成功时立减金仍在有效期内的,可以继续使用；退款成功时立减金已过有效期的,则立减金金额无法退回。</p>
                            <p>4.由于合作方的原因,出现系统问题等情况,导致客户无法享受立减金优惠的,上海农商银行不承担相应责任。上海农商银行保留更改或终止此推广活动之权利。</p>
                            <p>5.客户如有下述任何一种情况,其享受本活动的资格将被取消,包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、管制、客户自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡(个人卡)领用合约》或本活动细则及相关规定的。</p>
                            <p>6.如发现客户有利用活动规则或系统漏洞、作弊、冒用他人信息参与活动、进行虚假交易或者违法交易等手段恶意套取优惠奖励的,上海农商银行保留取消该客户参加本活动的权利,并有权取消或收回其因参加本活动所获的回馈和奖励。</p>
                            <p>7.在法律许可范围内,上海农商银行有权修订本活动条款及细则(包括但不限于参加资格、消费时间及奖励方式等)、暂停或取消本活动、并经相关途径(如上海农商银行官方网站、对账单、短信、信用卡微信公众号或各分支网点等)公告后生效。</p>
                            <p>8.其他未尽事宜,仍受《上海农商银行信用卡章程》、《上海农商银行信用卡(个人卡)领用合约》及其他相关文件约束。</p>
                            <p>9.活动详情以上海农商银行最新公布内容为准,或咨询24小时客服热线021-962999或4006962999。在法律许可范围内,上海农商银行保留活动最终解释权。</p>
                        </div>
                    </div>
                    <a
                        href="javascript:;"
                        class="more-rule"
                        @click="changeMoreRule"
                        v-show="!isShow"
                    >展开详情</a>
                    <div class="collect-wrap" v-show="isShow">
                        <div class="collect-btn" @click="changeMoreRule">
                            <i class="collect-icon"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return { isShow: false };
    },
    methods: {
        changeMoreRule() {
            this.isShow = !this.isShow;
            this.$test("WeChat a-detail-2");
        }
    }
};
</script>

<style lang="scss" scoped>
</style>